import React, { FC, useState } from 'react';

import defaultAvatarImg from '../../static/images/common/default_avatar_img.svg';
import { AVATAR_SHAPE, AVATAR_SIZE } from './constants';

interface AvatarProps {
  className?: string;
  alt?: string;
  src?: string;
  srcSet?: string;
  size?: 'large' | 'normal' | 'small' | number;
  shape?: 'round' | 'round-square' | 'square';
}

const Avatar: FC<AvatarProps> = ({
  className,
  alt,
  src = defaultAvatarImg,
  srcSet,
  size = 'normal',
  shape = 'round-square',
}: AvatarProps) => {
  const [error, setError] = useState(false);

  const sizeStyle = {
    width: typeof size === 'number' ? size : `${AVATAR_SIZE[size]}px`,
    height: typeof size === 'number' ? size : `${AVATAR_SIZE[size]}px`,
  };

  const handleImageError = () => {
    setError(true);
  };
  return (
    <div
      className={className}
      style={{
        ...sizeStyle,
        borderRadius: AVATAR_SHAPE[shape],
        overflow: 'hidden',
      }}
    >
      <img
        alt={alt}
        src={!error ? src : defaultAvatarImg}
        srcSet={!error ? srcSet : defaultAvatarImg}
        onError={handleImageError}
        style={sizeStyle}
      />
    </div>
  );
};

export default Avatar;
